interface MetricCardProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
  completion: number;
  onClick?: () => void;
  badge?: React.ReactNode;
}

export const MetricCard = ({
  icon: Icon,
  title,
  description,
  completion,
  onClick,
  badge,
}: MetricCardProps) => {
  return (
    <button
      onClick={onClick}
      className="group flex h-full w-full flex-col rounded-2xl border border-slate-200 bg-white p-6 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-md"
    >
      <div className="mb-8 flex items-start justify-between">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-primary/20 bg-primary/10">
          <Icon className="h-5 w-5 text-primary" />
        </div>
        <div className="flex items-center gap-2">
          {badge}
          <span className="text-2xl text-slate-400 transition-all group-hover:translate-x-1 group-hover:text-primary">
            ›
          </span>
        </div>
      </div>

      <h3 className="mb-2 font-heading text-base font-bold text-slate-950">
        {title}
      </h3>

      <p className="flex-1 text-sm leading-6 text-slate-500">
        {description}
      </p>

      <div className="mt-8">
        <div className="mb-2 flex items-center justify-between">
          <span className="text-sm font-semibold text-slate-900">Completion</span>
          <span className="text-base font-bold text-primary">{completion}%</span>
        </div>
        <div className="h-2 overflow-hidden rounded-full bg-slate-100">
          <div
            className="h-full rounded-full bg-primary transition-all"
            style={{ width: `${completion}%` }}
          />
        </div>
      </div>

      <div className="mt-5 flex items-center gap-1.5 text-sm font-medium text-primary">
        <span className="flex h-4 w-4 items-center justify-center rounded-full border border-primary text-[10px]">
          i
        </span>
        Click to expand
      </div>
    </button>
  );
};
